import Vue from 'vue'
import Vuex from 'vuex'
import sys from './modules/sys.js'
import busi from './modules/busi'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    sys,
    busi
  }

})

export default store
